import Box from '@material-ui/core/Box';
import useLayout from '../../styles/layout'
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { reserveRoutes } from '../../router/routeConfig'
import { useLocation } from 'react-router-dom'
import _, { min } from 'lodash'
import { SelectInput, TextInput, DateInput, RadioInput } from '../../components/common/components'
import { setFormValue, getReserveDate, getReserveTime, setOptionLoading, loadPreviousVaccineData } from '../../actions'
import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import Swal from 'sweetalert2'
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import ProgressBar from '../../components/ProgressBar'
import CircularProgress from '@material-ui/core/CircularProgress';
import { doGet, doPost } from '../../utils/AjaxRequests'
import { apiPrefixUrl } from '../../utils/connection'


const tableStyle = {
    borderCollapse: 'collapse',
    margin: '20px auto',

};

const thTdStyle = {
    border: '1px solid black',
    padding: '8px',
    textAlign: 'center',
    minWidth: '60px',
    whiteSpace: "pre-line"
};

export default function Explanation() {

    const layoutClasses = useLayout()

    const location = useLocation();

    const idx = _.findIndex(reserveRoutes, (o) => o.path === location.pathname)

    const option = (useSelector(state => state.get("option"))).toJS()

    const form = (useSelector(state => state.get("form"))).toJS()

    const dispatch = useDispatch()

    let history = useHistory();

    const handlechange = useCallback((field, value) => {

        const preForm = _.cloneDeep(form)

        const inputValue = field === "PAT_IDNO" ? value.toUpperCase() : value

        dispatch(setFormValue({
            field,
            value: inputValue
        }))

    }, [dispatch, form])


    const handleNextClick = () => {


        history.push('/vaccine_choice')
    }

    const [vaccineSchedule, setVaccineSchedule] = React.useState(null)

    const getVaccineSchedule = useCallback(async () => {
        const res = await doGet('https://q.kfsyscc.org/surveyapi/vaccine_brand_schedule')
        if (res.status) {
            setVaccineSchedule(res.msg.data)
        }
    }, [])

    useEffect(() => {
        getVaccineSchedule()
    }, [])




    if (option.config.length === 0 || vaccineSchedule === null) {
        return <div>loading...</div>
    }

    return <Box className={layoutClasses.page}>
        <Helmet>
            <title>{reserveRoutes[idx].name}</title>
        </Helmet>
        <ProgressBar />
        <Paper
            elevation={3}
            square
            className={layoutClasses.paper}
        >
            <Typography variant="subtitle1" gutterBottom align="center">
                {reserveRoutes[idx].name}
            </Typography>



            <Typography variant="subtitle2" gutterBottom>
                【配合衛生福利部最新宣布，本院提供第二階段（114年11月1日起）公費流感疫苗及公費新冠疫苗預約資格及接種對象如下：】
                <br />

            </Typography>

            <Box style={{ paddingLeft: "15px" }}>
                <Typography variant="subtitle2" gutterBottom style={{ fontWeight: 700 }}>※本院僅提供18 歲以上[2007/12/31前出生]之施打疫苗服務※</Typography>
                <Typography variant="subtitle2" gutterBottom>
                    (壹) 公費流感疫苗：
                </Typography>
                <Typography variant="subtitle2" gutterBottom>
                    一、流感疫苗接種對象：
                </Typography>
                <Typography variant="body2" gutterBottom style={{ lineHeight: 1.5, paddingLeft: "15px" }}>
                    1.50歲以上成人。<br/>
                    2.安養、長期照顧（服務）等機構之受照顧者及其所屬工作人員。<br/>
                    3.孕婦。<br/>
                    4.醫事及衛生防疫相關人員。<br/>
                    5.幼兒園托育人員、托育機構專業人員及居家托育人員（保母）。<br/>
                    6.6個月內嬰兒之雙親。<br/>
                    7.18-64歲具潛在疾病者（包括高風險慢性病人、BMI≥30者、罕見疾病患者及重大傷病患者）。<br/>
                    8.年滿18歲以上之高中、高職、五專一至三年級學生。<br/>
                    9.禽畜相關及動物防疫相關人員。

                </Typography>
                <Typography variant="subtitle2" gutterBottom>
                    二、流感疫苗接種注意事項：
                </Typography>
                <Typography variant="body2" gutterBottom style={{ lineHeight: 1.5, paddingLeft: "15px" }}>
                    1.單一流行季（每年10/1至次年3月）限一劑。<br/>
                    2.預約期間流感疫苗接種牌將依政府配給量調整，當同日出現兩廠牌時表示第一個廠牌打完後接第二個廠牌。
                </Typography>

                 <table style={tableStyle}>
                <thead>
                    <tr>
                        <th style={thTdStyle}>{vaccineSchedule.w1}</th>
                        <th style={thTdStyle}>{vaccineSchedule.w2}</th>
                        <th style={thTdStyle}>{vaccineSchedule.w3}</th>
                        <th style={thTdStyle}>{vaccineSchedule.w4}</th>
                        <th style={thTdStyle}>{vaccineSchedule.w5}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td style={thTdStyle}>{vaccineSchedule.v1}</td>
                        <td style={thTdStyle}>{vaccineSchedule.v2}</td>
                        <td style={thTdStyle}>{vaccineSchedule.v3}</td>
                        <td style={thTdStyle}>{vaccineSchedule.v4}</td>
                        <td style={thTdStyle}>{vaccineSchedule.v5}</td>
                    </tr>
                </tbody>
            </table>



            <Typography variant="subtitle2" gutterBottom>
                (貮) 公費新冠疫苗：
            </Typography>
            <Typography variant="subtitle2" gutterBottom>
                一、新冠疫苗接種對象：
            </Typography>


            <Typography variant="body2" gutterBottom style={{ lineHeight: 1.5, paddingLeft: "15px" }}>
            18歲以上民眾。


            </Typography>

            <Typography variant="subtitle2" gutterBottom>
                二、新冠疫苗接種注意事項：
            </Typography>


            <Typography variant="body2" gutterBottom style={{ lineHeight: 1.5, paddingLeft: "15px" }}>
                1.本院僅於臺北市衛生局供貨量能充足時，提供公費COVID-19疫苗預約、隨到隨打服務，當疫苗用罄時，關閉現場名額及預約服務。<br/>
                2.2025/10/01(含)起已接種 COVID-19 疫苗者，則無須再接種COVID-19疫苗。<br/>
                3.莫德納(Spikevax) LP.8.1 COVID-19 疫苗：<br/>
                &nbsp;&nbsp;・曾接種COVID-19疫苗，與前1劑COVID-19疫苗間隔12週(84天)以上。<br/>
                4.Novavax (Nuvaxovid) JN.1 COVID-19 疫苗：<br/>
                &nbsp;&nbsp;・自2025年11月12日起提供接種。<br/>
                &nbsp;&nbsp;・與2025/09/30(含)前接種之JN.1 COVID-19疫苗間隔12週(84天)以上。


            </Typography>

            <Typography variant="subtitle2" gutterBottom>
                【※疫苗接種服務相關注意事項※】
            </Typography>

            <Typography variant="body2" gutterBottom style={{ lineHeight: 1.5, paddingLeft: "15px" }}>
                (1)每日疫苗網路預約截止時間為接種日上午08:00，當日現場報名請逕洽3F南區門診櫃台；當本院分配到的疫苗用罄時，關閉現場名額及預約服務。<br/>
                (2)預約上午診民眾請於11:30前完成報到；預約下午診民眾請於15:00前完成報到。<br/>
                (3)依據主管機關函示，本院疫苗接種服務將收取掛號費150元。<br/>
                (4)提醒預約接種民眾到院報到時，應備妥健保卡和可證明符合接種資格之身分證明文件(例如： 執業登記證、醫療機構工作證、勞健保證明或在職證明資料等，原住民身分證明文件如戶口名簿或戶籍謄本）， 孕婦預約接種COVID-19疫苗前，建議先與婦產科主治醫師討論是否合適接種，接種報到時請攜帶孕婦健康手冊。<br/>
                (5)報到時仍會確認您的年齡及身份對象資格，資格不符開放接種身份對象資格時，將當場直接取消接種。接種前評估時，請說明過往疫苗接種史，以利醫生評估。


            </Typography>
                

            </Box>








        </Paper>
        <Button
            variant="contained"
            color="primary"
            style={{ margin: "30px auto" }}
            onClick={() => { handleNextClick() }}
        >
            我了解以上說明&nbsp;&nbsp;開始預約
        </Button>
    </Box>
}